import { date2dayofweeks } from "./date2dayofweeks";
const generateLatestSevenDays = () => {
  const dates = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
    const formattedDate = `${String(date.getDate()).padStart(2, "0")}.${String(
      date.getMonth() + 1
    ).padStart(2, "0")}`;
    dates.push(formattedDate);
  }
  return dates;
};

export const generateLatestSevenDayOfWeek = () => {
  const dates = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
    const formattedDate = `${date2dayofweeks(date)}`;
    dates.push(formattedDate);
  }
  return dates;
};

export const generateLatest7DaysOfWeekWithoutToday = () => {
  const dates = [];
  for (let i = 1; i <= 7; i++) {
    const date = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
    const formattedDate = `${date2dayofweeks(date)}`;
    dates.push(formattedDate);
  }
  return dates;
};

export default generateLatest7DaysOfWeekWithoutToday;
